import React from 'react';

const DebugInfo: React.FC = () => {
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  // return (
  //   <div className="fixed bottom-4 right-4 bg-black/80 text-white p-2 rounded text-xs z-50">
  //     <div>Screen: {window.innerWidth}x{window.innerHeight}</div>
  //     <div>Theme: {document.documentElement.classList.contains('dark') ? 'dark' : 'light'}</div>
  //     <div>User Agent: {navigator.userAgent.includes('Mobile') ? 'Mobile' : 'Desktop'}</div>
  //   </div>
  // );
};

export default DebugInfo;
